// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__LeEOi","search":"Settings_search__3Xiss","filter":"Settings_filter__1HZpG"};